<template>
  <div>
    <b-modal
      id="modal-term"
      size="xl"
      ok-title="Agree"
      cancel-title="Don't Agree"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <template #modal-header="{ close }">
        <div class="d-flex ms-auto">
          <h5 @click="close()" style="font-size: 2rem; cursor: pointer">x</h5>
        </div>
      </template>
      <div class="d-grid">
        <div style="text-align: -webkit-center">
          <div class="mb-5">
            <h1 style="color: #51646b">Terms & Condition</h1>
            <h2 style="color: #51646b">Please read before clicking Agree.</h2>
          </div>
          <div class="term-window mb-3">
            These following Terms of Use constitute a legally binding agreement
            made between you, whether personally or on behalf of an entity
            (hereinafter referred to as "you" or "customer”, or each a "user”
            and collectively the "users”) and Carbonwize (hereinafter referred
            to as "we", "us", "our" or "Carbonwize”) regarding your access to
            and use of the https://carbonwize.io website as well as any social
            media channels, social networks, communities or mobile applications
            related, linked, or otherwise connected thereto (collectively, the
            "Platform").
            <br />
            <br />
            These Terms of Service (hereinafter referred to as "Terms”) apply to
            all contracts concluded in the context of the business relationship
            between Carbonwize and its business customers in connection with the
            software-as-a-service solutions offered by Carbonwize Co., Ltd.
            Please read this Privacy Policy, our Terms of Service carefully as
            you must agree to each in order to have permission to use our
            service.
            <br />
            <br />
            YOU WILL NOT BE ABLE TO USE OUR SERVICE IF YOU DO NOT AGREE TO THESE
            POLICIES.
            <br />
            <br />
            1. Definitions
            <br />
            <br />
            (i) Carbonwize is a Enterprise software-as-a-service platform that
            allows its customers to collect & analyze a company's activity on
            Greenhouse Gas Emission data, to track and plan emission reduction
            measures and to optimize their carbon footprint and sustainability
            development. (ii) "Additional Services" means the additional
            services, if any, to be provided by Carbonwize under the Individual
            Contract.
            <br />
            <br />
            (iii) "Authorized Users" means the Customer's employees who are
            authorized to access the SaaS Services within the scope of the
            rights of use acquired by the Customer.
            <br />
            <br />
            (iv) "Confidential Information" means all information disclosed to
            one party by the other party, whether in writing, electronically or
            orally, digitally or in any other form that is expressly marked as
            "confidential” or should be considered confidential due to the
            nature of the information or the circumstances of its disclosure.
            Confidential Information includes, but is not limited to,
            information relating to technologies, inventions, software and/or
            hardware, new products, intellectual property, know-how, marketing
            plans, financial situations, business strategies, business
            relationships, business plans, business calculations, pricing policy
            or personnel matters of one of the parties. Confidential Information
            also includes the content of the Individual Contract concluded
            between the Customer and Carbonwize.
            <br />
            <br />
            (v) "Consulting Services” means individually agreed consulting
            services, which Carbonwize provides to the Customer on the basis of
            an Individual Contract.
            <br />
            <br />
            (vi). "Contract" is the Individual Contract including these Terms.
            <br />
            <br />
            (vii) "Contractual Services" are the SaaS Services and/or Additional
            Services to be provided according to the Individual Contract.
            <br />
            <br />
            (viii) "Customer" means Carbonwize's contractual partner named in
            the Individual Contract.
            <br />
            <br />
            (ix) "Customer Data" means all profile information and data as well
            as other content and information that the Customer provides to
            Carbonwize in connection with the use of the SaaS Services. Customer
            Data includes Emission Data.
            <br />
            <br />
            (x) "Emission Log” means all non-personal information and data
            provided by users that serve as a basis to calculate and/or analyze
            the footprint of a Customer, including the information from Logs,
            which the Customer collects from suppliers and own customers and/or
            processes by means of the SaaS Services.
            <br />
            <br />
            (xi) "Feedback” means Customer's opinions, comments or suggestions
            regarding any possible development, modification, correction,
            improvement or enhancement of Carbonwize's software, products and/or
            services.
            <br />
            <br />
            (xii) "PDPA” means Regulation (TH) of Thailand's Personal Data
            Protection Act of June 2022 on the protection of data processing,
            data collection, data storage, and data consent protocols. Once
            implemented, the PDPA is expected to change the landscape of
            personal data protection in Thailand
            <br />
            <br />
            (xiii) "Individual Contract" means the SaaS contract concluded
            between the Customer and Carbonwize for the provision of SaaS
            Services and/or Consulting Services. An Individual Contract is also
            a contract that is concluded exclusively online via the Website. In
            these cases, the Individual Contract comes into effect with the
            order confirmation from Carbonwize.
            <br />
            <br />
            (xiv) "Personal Data” means personal identifiable information as
            defined in PDPA.
            <br />
            <br />
            (xv) "Platform" means the website application platform operated by
            Carbonwize and accessible via the Website.
            <br />
            <br />
            (xvi) "SaaS Services" means the SaaS-based services provided by
            Carbonwize via the Platform by means of a software-as-a-service
            solution, including customer information and retention services.
            <br />
            <br />
            (xvii) "Support Services” means technical support services where
            Carbonwize will handle errors or faults that occur in the SaaS
            Service and have been reported to Carbonwize. An error exists in
            particular if the SaaS Service does not fulfill the functions
            specified in the Individual Contract or the service description. An
            error shall not be deemed to exist if the aforementioned
            malfunctions occur as a result of improper handling of the SaaS
            Service and/or breaches of obligations by the Customer.
            <br />
            <br />
            (xviii) "Website" means the website operated by Carbonwize, which is
            available at: https://carbonwize.io /.
            <br />
            <br />
            2. Object of the Contract, Contract conclusion, amendments to the
            Terms
            <br />
            <br />
            (i) The object of the Contract is the provision of the SaaS Services
            commissioned by the Customer and agreed in the Individual Contract
            as well as the provision of additional services, if and insofar as
            these are specified in the Individual Contract.
            <br />
            <br />
            (ii) Carbonwize reserves the right to amend or supplement these
            Terms with effect for the future. Carbonwize shall inform the
            Customer about any amendments and supplements by notifying the
            Customer of the content of the amended or supplemented provisions in
            text form (e.g. by email or by notification when logging onto the
            Platform) in advance and with a reasonable period of notice, but at
            least four weeks before the amendments/supplements are scheduled to
            take effect. The amendments/supplements shall be deemed accepted by
            the Customer if it does not object to the amendments/supplements in
            text form within four weeks of receipt of the notification. If,
            however, the Customer objects in accordance with the previous
            sentence, the Contract shall continue to apply unchanged under the
            previous conditions. In its notice of the change, Carbonwize shall
            point out to the Customer separately the Customer's right of
            objection and the aforementioned legal consequences of not
            responding.
            <br />
            <br />
            3. Scope of service, authority to change
            <br />
            <br />
            (i) This Contract covers neither the Customer's connection to the
            internet and maintenance of the network connection nor the
            procurement and provision of the hardware required for this on the
            part of the Customer. The Customer shall be obliged to create and
            maintain the technical prerequisites for access to the SaaS Services
            in its own area, at its own expense and risk.
            <br />
            <br />
            (ii) The SaaS services can be used without additional support from
            Carbonwize. If the Customer wishes to make use of onboarding
            services or other services in connection with configuration,
            customizing, integration, Co-Creation, training or adaptation of the
            SaaS Services a separate assignment and a separate remuneration is
            required.
            <br />
            <br />
            (iii) Carbonwize continuously develops and enhances the SaaS
            Services and the Platform. Updates to the core product shall always
            be provided to the Customer free of charge. However, in the event of
            extensive updates and extensions of the functional scope (e.g. the
            addition of modules) of the Platform or the SaaS Services,
            Carbonwize shall be entitled to classify these as a new product or
            upgrade and make them available to the Customer for an additional
            fee. Insofar as Carbonwize provides such upgrades and extensions
            free of charge, the Customer shall have no legal claim to their
            provision. Carbonwize shall inform the Customer about any
            discontinuation of the free services. (iv) Carbonwize reserves the
            right to make changes in order to adapt the Platform and SaaS
            Services to the state of the art, changes for optimisation purposes
            (in particular to enhance user-friendliness), as well as changes to
            content, insofar as the latter are necessary to correct errors, for
            updating and completing content, for technically optimizing programs
            or for licensing reasons. If such a change leads to a not only
            insignificant devaluation of the Contractual Services, the Customer
            shall be entitled to either demand a reduction of the remuneration
            in line with the devaluation or terminate the Contract without
            notice. This right of termination may be exercised within a period
            of eight weeks from the occurrence of the change.
            <br />
            <br />
            4. User account, access data
            <br />
            <br />
            (i) The Customer's access to the SaaS Services shall be
            password-protected via the Platform, using the access data assigned
            to the Customer by Carbonwize. Carbonwize shall provide the Customer
            with access data for the number of users agreed upon in the
            Individual Contract. For technical reasons, access data for a
            personal login will only be sent by email with an encrypted link.
            For this reason, the Customer must inform Carbonwize of the
            corresponding email addresses of the Authorized Users. The access
            data is individualized and may only be used by the Customer
            concerned or the Authorized Users. The Customer shall instruct the
            Authorized Users to choose a sufficiently secure password and to
            keep their access data, including the password, secret and to
            protect this information against unauthorized access by third
            parties. For security reasons and to prevent misuse, Carbonwize
            recommends that Customers change their passwords at regular
            intervals.
            <br />
            <br />
            (ii) The sharing of access data and otherwise permitting or enabling
            the use of user accounts or the SaaS Services by third parties is
            strictly prohibited.
            <br />
            <br />
            (iii) The Customer shall be obliged to inform Carbonwize without
            undue delay if it is aware of or suspects misuse of access data or
            passwords. In the event of misuse or suspected misuse, Carbonwize
            shall be entitled to block access to the Platform until the
            circumstances have been clarified and the misuse has ceased.
            Carbonwize also reserves the right to change the Customer's access
            data for security reasons; in such cases, Carbonwize shall inform
            the Customer without undue delay. This shall not affect the
            assertion of further rights and claims by Carbonwize, in particular
            claims for damages.
            <br />
            <br />
            5. Support Services
            <br />
            <br />
            Carbonwize will provide the Customer with Support Services during
            the Contract period without additional remuneration. Depending on
            the Customer's choice, Support Services shall be provided by the
            Customer Success Manager assigned to the Customer (by phone or
            email), or by Carbonwize's general email support (which is available
            at: support@carbonwize.io). The Customer's dedicated Customer
            Success Manager shall be informed about each support case and assist
            in finding a solution. Support Services shall be available from
            Monday to Friday from 10 AM until 6 AM (GMT+7). This shall not apply
            on days that are public holidays in Thailand. Requests received
            outside of these support hours shall be deemed to have been received
            during the next working day. During business hours, the initial
            response to all support requests shall occur within no more than 24
            hours.
            <br />
            <br />
            6. Consulting Services
            <br />
            <br />
            (i) If Consulting Services are agreed in an Individual Contract, the
            Terms of this Contract shall apply. The specific scope of Consulting
            Services and the remuneration for them shall be regulated in the
            respective Individual Contract.
            <br />
            <br />
            (ii) Carbonwize shall provide the Consulting Services through
            suitable employees or subcontractors. A right to claim the
            performance of services by certain persons does not exist. The
            Customer is not authorized to give instructions to the employees of
            Carbonwize.
            <br />
            <br />
            (iii) Carbonwize shall determine the manner of service provision
            itself, unless otherwise agreed. The Customer shall only be entitled
            to a specific form of presentation of the results if this has been
            expressly agreed.
            <br />
            <br />
            7. Duties of cooperation on the part of the Customer
            <br />
            <br />
            (i) The Customer shall support the execution of the Contract by
            actively cooperating in an appropriate manner. In particular, the
            Customer shall be responsible for ensuring, at no charge, all
            prerequisites within its sphere of operation that are necessary for
            the proper provision of Carbonwize's services. This shall include,
            in particular, the conditions set out in the Individual Contract as
            well as those specified in the following Clauses 1.
            <br />
            <br />
            (ii) The Customer shall be required A. to create and maintain the
            technical prerequisites for access to the SaaS Services in its own
            area, particularly with regard to the hardware and operating system
            software used, connection to the internet and ensuring that its
            browser software is up to date; B. to take the necessary precautions
            to secure its systems during the entire Contract period, in
            particular to use the standard browser security settings and to
            employ up-to-date protection mechanisms to guard against malware; C.
            to ensure that the data stored in its user account is always up to
            date. In the event of changes or inaccuracies in the stored data,
            the Customer must update or correct this information without undue
            delay and without being asked.
            <br />
            <br />
            (iii) Notwithstanding Carbonwize's obligation to back up data
            according to Clause 2 and 3 the Customer shall be responsible for
            maintaining and protecting the Customer Data and undertakes to back
            these up regularly. Every data backup by the Customer must be
            carried out in such a way that the recovery of Customer Data is
            possible at any time. The SaaS Service provides corresponding backup
            functionalities.
            <br />
            <br />
            (iv) The Customer shall be required to inform Carbonwize in text
            form about any service disruptions (service defects, lack of
            availability) without undue delay after becoming aware of them, and
            shall use reasonable efforts to assist Carbonwize in eliminating the
            service disruptions.
            <br />
            <br />
            8. Further obligations on the part of the Customer, prohibited
            activities, indemnification
            <br />
            <br />
            (i) The Customer shall be required to use the SaaS Services provided
            by Carbonwize only to the contractually agreed extent and for the
            contractually intended purpose and within the framework of the
            applicable legal provisions, and to refrain from all actions that
            could endanger or disrupt the functioning of the SaaS Services.
            <br />
            <br />
            (ii) In particular, the Customer shall be obliged A. not to use the
            SaaS Services to create, store or send any content that is
            pornographic, glorifies violence, is discriminatory, prohibited by
            law, harmful to young people, in violation of moral standards or
            harmful to public order and safety;
            <br />
            <br />
            B. not to violate any copyright (e.g. for photos, graphics),
            trademarks (e.g. logos) and other property rights or other legally
            protected goods of Carbonwize or third parties (e.g. personal
            rights) when using the SaaS Services; C. not to use the SaaS
            Services to send unsolicited messages that could be considered spam;
            D. to access the SaaS Services exclusively via the interfaces
            provided by Carbonwize; E. to ensure that its information and data
            transmitted via the SaaS Services are not infected with viruses,
            worms or Trojans; F. not to use any devices, products or other means
            that serve to circumvent or overcome technical measures used by
            Carbonwize for the prevention of unauthorized use; G. not to use any
            web crawlers, robots, spiders, site search/retrieval applications or
            other automated means or comparable technologies to access the SaaS
            Services or to retrieve or evaluate content.
            <br />
            <br />
            (iii) The Customer shall be obliged to inform the Authorized Users
            of the above provisions and to ensure compliance with them.
            <br />
            <br />
            (iv) The Customer shall indemnify Carbonwize against all claims
            asserted by third parties against Carbonwize due to violation of
            their rights or due to rights infringements caused by content
            created or transmitted by the Customer using the SaaS Services. The
            Customer shall also bear the necessary costs of Carbonwize's legal
            defense in this regard, including court and lawyer fees. This
            indemnification shall not apply if the Customer is not responsible
            for the rights infringement. This shall not affect the assertion of
            further rights and claims by Carbonwize, in particular the right of
            extraordinary termination for good cause and claims for damages.
            <br />
            <br />
            9. Intellectual property, rights of use, naming of references
            <br />
            <br />
            (i) The Platform and the SaaS Services, including the homepage
            layout, the graphics and images used, the content as a whole as well
            as individual pieces of content including the system presentation
            texts, as well as the software code on which the SaaS Services and
            the Platform are based and any work result of Additional Services by
            Carbonwize may be protected in whole or in part by copyright or
            other intellectual property rights. All rights are exclusively
            reserved by Carbonwize or Carbonwize's licensors.
            <br />
            <br />
            (ii) In particular, the Customer shall be prohibited from A.
            reproducing, modifying, adapting, translating, decompiling,
            disassembling or deriving the Platform or the SaaS Services,
            performing reverse engineering, or otherwise attempting to derive
            the source code underlying the SaaS Services or the Platform. B.
            using, evaluating or displaying the Platform or the SaaS Services in
            order to construct, modify or otherwise create a network
            environment, a program, an infrastructure or parts thereof with
            features comparable to those of the SaaS Services or the Platform.
            This shall not affect the mandatory legal regulations on permissible
            use pursuant to The Copyright Act.
            <br />
            <br />
            (iii) In accordance with the Individual Contract and the following
            provisions, the Customer shall be granted the non-exclusive,
            non-transferable right, limited to the duration of the Individual
            Contract, to access the SaaS Services and the Platform and to use
            the work result of Additional Services. This right of use shall be
            limited to the number of Authorized Users specified in the
            Individual Contract. Carbonwize shall be entitled to take technical
            measures to prevent use beyond the permissible scope, in particular
            to install access barriers.
            <br />
            <br />
            (iv) In its relationship with Carbonwize, the Customer shall be
            entitled to all rights to the Emission Data. However, the Customer
            shall grant Carbonwize the irrevocable right, free of charge, to
            collect Emission Data in anonymous form to the extent permitted by
            law, and to use this to create statistical reports and
            presentations, to provide and enhance the Platform and SaaS
            Services, and to provide enhanced features. The Customer shall have
            no rights whatsoever to the aggregated data and results.
            <br />
            <br />
            (iv) Carbonwize shall be entitled to include the Customer in
            Carbonwize's reference list and to name the Customer in a suitable
            manner as a reference on the Website and in printed and digital
            marketing and advertising materials. For this purpose, the Customer
            shall grant Carbonwize free of charge a non-exclusive, worldwide,
            non-transferable right to use the Customer's company name and logo.
            If using the company name and/or logo is subject to particular
            requirements, the Customer shall inform Carbonwize of these without
            request. The Customer shall be entitled to withdraw the granted
            right of use at any time, with effect for the future, by submitting
            a notification to that effect in text form.
            <br />
            <br />
            10. Remuneration and payment, payment terms (i) The remuneration
            owed by the Customer for the Contractual Services shall be specified
            in the Individual Contract.
            <br />
            <br />
            (ii) The remuneration for the Contractual Services shall be paid in
            advance for the service or billing period specified in the
            Individual Contract and the subsequent extension periods.
            <br />
            <br />
            (iii) Unless otherwise expressly agreed in the Individual Contract,
            invoices issued by Carbonwize shall be due for payment in full
            within 7 days after receipt by the Customer. Carbonwize shall be
            entitled to send invoices to the Customer by email or to make them
            available to the Customer online.
            <br />
            <br />

            (iv) Any set-off of claims by the Customer against claims of
            Carbonwize shall only be possible to the extent to which the
            Customer's claims are legally established or not disputed.
            <br />
            <br />
            (v) The pricing can be in US Dollars and Thai Baht – unless they are
            expressly referred to as gross prices – do not include the statutory
            turnover tax applicable at the relevant time. Unless expressly
            stated otherwise, the Customer shall be responsible for all other
            taxes and duties that apply to the sale and use of the SaaS Services
            and Additional Services. The Customer shall pay Carbonwize for the
            SaaS Services and Additional Services without any deductions for
            such taxes and duties. If Carbonwize is obligated to levy or pay
            such taxes and duties, Carbonwize shall invoice the Customer for
            these taxes and duties, unless the Customer submits to Carbonwize a
            valid exemption certificate issued by the competent tax office which
            states that no tax needs to be levied.
            <br />
            <br />
            11. Restriction/blocking of the user account
            <br />
            <br />
            (i) Carbonwize reserves the right to temporarily or permanently
            restrict the Customer's use of the SaaS Services or to temporarily
            or permanently block the Customer's access to the SaaS Services if
            A. there is concrete evidence that the Customer has allowed or in
            any other way deliberately enabled an unauthorized third party to
            use the user account or the access data; B. there is concrete
            evidence that a breach of one of the obligations under Clauses 10.1
            and 10.2 has occurred; C. there is concrete evidence of misuse,
            unauthorized or fraudulent use of the user account or such use is to
            be feared on the basis of concrete evidence; D. the Customer fails
            to pay the remuneration owed within 30 days of the due date, despite
            a reminder; E. the Customer repeatedly violates other provisions of
            these Terms despite a warning; F. other circumstances exist that
            would entitle Carbonwize to terminate the Contract for good cause.
            <br />
            <br />
            (ii) Carbonwize shall inform the Customer without undue delay of any
            temporary or permanent restriction or blocking of its user account,
            stating the reasons.
            <br />
            <br />
            12. Limitations of Liability
            <br />
            <br />
            (i) Carbonwize shall only be liable without limitation for damages
            in case of intent and gross negligence on the part of Carbonwize,
            its vicarious agents and/or legal representatives. With regard to
            damages caused by slight negligence, Carbonwize shall only be liable
            in case of a breach of an essential contractual obligation.
            Essential contractual obligations are those obligations whose
            fulfillment makes possible the correct execution of the Contract in
            the first place and on whose compliance the Customer may regularly
            rely. In the event of a breach of such an essential contractual
            obligation, the liability of Carbonwize shall be limited to the
            damages typical for this type of contract which Carbonwize could
            have foreseen at the time when the Contract was concluded based on
            the circumstances known at that time. For an individual case of
            damage, liability is limited to the amount of remuneration per
            contract year, but not more than 300 USD.
            <br />
            <br />
            (ii) Carbonwize shall be liable for the loss of data in accordance
            with the preceding paragraph only if and insofar as such a loss
            could not have been avoided by the Customer through appropriate data
            backup measures.
            <br />
            <br />
            (iii) The aforementioned limitations of liability as well as all
            other limitations of liability contained in these Terms shall not
            apply in the event of the assumption of express guarantees, in the
            event of claims due to a lack of warranted characteristics, or to
            damages resulting from injury to life, limb or health. In these
            cases, Carbonwize shall also be liable without limitation for slight
            negligence. The liability of Carbonwize under the Kingdom of
            Thailand Liability Act also remains unaffected.
            <br />
            <br />
            13. Confidentiality
            <br />
            <br />
            (i) With regard to Confidential Information of the other party, each
            party shall be obliged to A. keep such information strictly
            confidential and only use it in connection with the contractual
            purposes; B. take appropriate confidentiality measures to secure
            such information against unauthorized access by third parties. This
            also includes technical security measures that take into account the
            state of PDPA; C. only disclose or pass on such information to those
            employees and bodies as well as commissioned service providers who
            or which need to know this information for the execution of the
            Contract, and who or which are subject to an obligation to maintain
            confidentiality that guarantees at least the same level of
            protection as this agreement; D. not disclose or pass on such
            information to third parties, unless the third party is a consultant
            or potential investor of the receiving party and the respective
            consultant or investor is subject to an obligation to maintain
            confidentiality that guarantees at least the same level of
            protection as this agreement or is already professionally bound to
            secrecy.
            <br />
            <br />
            (ii) The confidentiality obligations under Clause 13 shall not apply
            to Confidential Information that can be proven to A. have been known
            or generally accessible to the public before its communication or
            transfer or becomes known or generally accessible to the public at a
            later date, as long as there is no breach of a confidentiality
            obligation; B. have been already known to the receiving party prior
            to disclosure by the disclosing party, as long as there is no breach
            of a confidentiality obligation; C. have been developed
            independently by the receiving party without using or referring to
            the Confidential Information of the disclosing party; D. have been
            handed over or made available to the receiving party by an
            authorized third party, as long as there is no breach of a
            confidentiality obligation; or E. be required to be disclosed due to
            mandatory legal provisions or a decision of a court and/or an
            authority.
            <br />
            <br />
            (iii) The confidentiality obligations under this Clause 13 shall
            remain in force for a period of 2 years after termination of the
            Contract.
            <br />
            <br />
            14. Contract term, consequences of termination
            <br />
            <br />
            (i) The beginning of the Contract, its duration and any ordinary
            rights of termination shall be regulated in the Individual Contract.
            This shall not affect the right of extraordinary termination.
            <br />
            <br />
            (ii) If the Individual Contract does not contain any provision on
            termination rights, the contract may be terminated with one months'
            notice.
            <br />
            <br />
            (iii) Carbonwize shall block the Customer's access to the Platform
            immediately after termination of the contractual relationship and,
            at the choice of the Customer, permanently erase or return all of
            the Customer Data and other content no later than one month after
            termination of the Contract. This shall not affect any statutory
            retention periods and it shall not affect Carbonwize's right to use
            Emission Log in an anonymized form. Once erased, the content cannot
            be restored. It shall be the responsibility of the Customer to
            ensure that it has backed up or copied all data it requires, in
            particular Customer Data, before termination of the contractual
            relationship. At the Customer's written request, Carbonwize shall
            support the Customer in this process in return for appropriate
            remuneration and make the data available to the Customer on a
            standard data medium or by way of remote data transmission. The
            Customer must declare its request at the latest at the time of
            termination or, in the case of termination by Carbonwize,
            immediately after receipt of the notice of termination.
            <br />
            <br />
            15. Applicable law and place of jurisdiction (i) The Contract shall
            be subject to Thailand law. (ii) The courts in Thailand shall have
            exclusive jurisdiction for all disputes arising from or in
            connection with this Contract.

            <br />
            <br />
            <!-- Carbonwize's Privacy Policy describes how Carbonwize collects, uses, stores, shares and secures your
                        personal data ("we", "us", "our" or "Carbonwize”)
                        <br/>
                        Carbonwize is a Enterprise software-as-a-service platform that allows its customers to collect &
                        analyze a company's activity on Greenhouse Gas emission data, to track and plan emission
                        reduction measures and to optimize their carbon footprint and sustainability development.
                        <br/>
                        Please read this Privacy Policy, our Terms of Service carefully as you must agree to each in
                        order to have permission to use our service.
                        <br/>
                        YOU WILL NOT BE ABLE TO USE OUR SERVICE IF YOU DO NOT AGREE TO THESE POLICIES.

                        <br/>
                        <br/>

                        1. General information on data processing
                        <br/>
                        1.1. Extend of processing personal data
                        <br/>
                        We generally only process personal data of our users insofar as this is necessary to provide a
                        functional website and our content and services. The processing of personal data of our users
                        takes place regularly only with the consent of the user. An exception applies in cases in which
                        prior consent cannot be obtained for factual reasons and the processing of the data is permitted
                        by law.
                        <br/>
                        <br/>
                        1.2. Legal basis for the processing of personal data
                        <br/>
                        Insofar as we obtain the data subject's consent for the processing of personal data, the
                        Personal Data Protection Act (PDPA) serves as the legal basis. When processing personal data,
                        that is necessary for the performance of a contract to which the data subject is a party, PDPA
                        as the legal basis. This also applies to processing operations that are necessary to carry out
                        pre-contractual measures. Insofar as processing of personal data is necessary to fulfill a legal
                        obligation to which our company is subject, PDPA serves as the legal basis. In the event that
                        vital interests of the data subject or another natural person require the processing of personal
                        data, PDPA serves as the legal basis. If processing is necessary to safeguard the legitimate
                        interests of our company or a third party and if the interests, fundamental rights and freedoms
                        of the data subject do not outweigh the former interest, PDPA serves as the legal basis for
                        processing.
                        <br/>
                        <br/>
                        1.5.3 Data deletion and storage duration<br/>
                        The personal data of the data subject will be deleted or blocked as soon as the purpose of
                        storage no longer applies. We may store personal data if this has been prescribed by the Kingdom
                        of Thailand regulations, laws, or other regulations to which the person responsible is subject.
                        The data will also be blocked or deleted if a storage period prescribed by the standards
                        mentioned expires unless there is a need for further storage of the data for the conclusion or
                        performance of a contract.
                        <br/>
                        <br/>
                        2. Provision of the website and creation of log files<br/>
                        Every time the Website is accessed by a visitor, this Website collects general data and
                        information in connection with your visit. This general data and information is stored in the
                        log files of the server and concerns the following data: browser types and versions used, the
                        operating system used by the accessing system, the webpage from which an accessing system
                        arrived on this Website (known as a referrer), sub-websites that are accessed on this Website
                        via an accessing system, date and time of an access to the Website, IP address, internet service
                        provider of the accessing system other similar data and information aimed at averting danger in
                        the event of attacks directed at our IT systems. When processing this usage data, we do not draw
                        any conclusions as to the visitor. We need this data in order to correctly deliver the content
                        of the Website, optimize the content of and the advertising for this Website, ensure the
                        permanent functionality of our IT systems and the technology underlying this Website as well as
                        provide to authorities the information necessary for purposes of conducting e. g. criminal
                        proceedings in the event of a cyberattack. The legal basis for this processing activity is PDPA.
                        This data in anonymized form is analyzed by us statistically and with the aim of increasing data
                        protection and data security. The anonymous data of the server log files is stored separately
                        from all personal data provided by a visitor.
                        <br/>
                        <br/>
                        3. What's about those cookies?<br/>
                        Carbonwize does not make use of Cookies in operating our website https://carbonwize.io . Cookies are
                        text files that are stored on your device. Cookies remain on your device and allow companies to
                        recognize your browser on the next visit (persistent cookies).
                        <br/>
                        <br/>
                        4. Use of third-party provider tools<br/>
                        4.1 Amazon Web Services EMEA SARL ("AWS"), situated at 38 Avenue John F. Kennedy, L-1855
                        Luxembourg. Please find more information in AWS's General Terms of Service and their Privacy
                        Policy .
                        <br/>
                        <br/>
                        4.2 Thailand Greenhouse Gas Management Organization ("TGO"), situated at 120<br/>
                        Ratthaprasasanabhakti Building, 9th Fl. The Government Complex Commemorating His Majesty, Chaeng
                        Wattana Road Laksi, Bangkok 10210 Thailand. Please find more information in TGO's Security
                        Policy and their Privacy Policy
                        <br/>
                        <br/>
                        4.3 Stripe Payments Europe, Limited ("Stripe"), situated at 1 Grand Canal Street Lower Dublin,
                        Ireland. Please find more information in Stripe's General Terms of Service and their Privacy
                        Policy.
                        <br/>
                        <br/>
                        5. Registration<br/>
                        If you register on our website, then we store your personal data to create your Carbonwize account.
                        Collected data: Email address, first name, last name, company, position in your company Purpose
                        of use: Creation of account requested Storage period: As a general rule, the data is only stored
                        for as long as is needed to fulfill the purpose. Legal basis: PDPA: You can delete your Carbonwize
                        account at any time by sending an email to support@carbonwize.io
                        <br/>
                        <br/>
                        6. Conclusion of a contract<br/>
                        Upon conclusion of the contract, we collect, process and use personal data only to the extent
                        that they are necessary for the establishment, content or modification of the legal
                        relationship. Collected data: Email address, first name, last name, payment information, VAT ID
                        Purpose of use: conclusion of a contract, purchase Storage period: As a general rule, the data
                        is only stored for as long as is needed to fulfill the purpose. We only transfer personal data
                        to third parties if this is necessary for the execution of the contract, for example to the
                        companies entrusted with the delivery of the goods or the credit institution commissioned with
                        the handling of payments. A further transmission of the data does not take place or only if you
                        have expressly agreed to the transmission. Your data will not be passed on to third parties
                        without your express consent, for example for advertising purposes.
                        <br/>
                        <br/>
                        7. Rights of data subjects<br/>
                        If your personal data is processed, you are considered a data subject within the meaning of the
                        PDPA and you have the following rights against Rocket Internet as data controller:
                        <br/>
                        <br/>
                        7.1 Right of Access<br/>
                        Right to information according to PDPA: You have the right to obtain information about the
                        personal data processed by us, the processing purposes, the categories of processed personal
                        data, the recipients or categories of recipients to whom your data was or are being disclosed,
                        the planned period of storage or the criteria for determining the duration of storage, the right
                        of correction, deletion, limitation of processing, objection to processing, complaint to a
                        supervisory authority, the origin of your data, if they were not collected by us, the existence
                        of automated decision-making including profiling and possibly significant information on the
                        logic applied and the scope and intended impact of such processing, as well as your right to be
                        informed of what guarantees according to PDPA exist in case of redirection of data in third
                        countries.
                        <br/>
                        <br/>
                        7.2 Right to Correction<br/>
                        Right to correction according to PDPA: You have the right to immediate correction of incorrect
                        data concerning you and/or completion of incomplete data.
                        <br/>
                        <br/>
                        7.3 Right to Deletion<br/>
                        Right to deletion according to PDPA. You have the right to demand the deletion of your personal
                        data if the requirements of PDPA are met. This right does not apply if the processing is
                        necessary for the exercise of the right to freedom of expression and information, for the
                        fulfillment of a legal obligation, for reasons of public interest or for the pursuit, exercise
                        or defense of rights.
                        <br/>
                        <br/>
                        8. Privacy policy changes<br/>
                        This Privacy Policy may change at any time, in particular pursuant to any changes made to the
                        laws and regulations in force, or if we make any substantial improvements, additions or changes
                        to our practices regarding your personal data. We will ensure we keep you informed of any
                        substantial changes in due course. If you have any questions regarding this Privacy Policy, feel
                        free to email us directly at support@carbonwize.io. -->
          </div>
          <!-- <div>
                        <input style="width: 20px" id="inputField" type="checkbox" v-model="agree" />
                        <span>
                            I agree to the
                            <a href="/term" style="color: #2867eb">
                                Terms and Conditions, Privacy Policy
                            </a></span>
                    </div> -->
        </div>
        <button
          class="btn-start mx-auto mt-3"
          style="border: 1px solid #265054"
          @click="closeModal()"
        >
          Close
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      agree: false,
    };
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("modal-term");
    },
  },
};
</script>

<style lang="scss">
#modal-term {
  border-bottom: none !important;
}

.term-window {
  height: 45vh;
  background-color: #f8f8f9;
  color: #abb6bb;
  width: 70%;
  padding: 12px;
  border-radius: 8px;
  border: 2px solid #abb6bb;
  overflow: auto;
  text-align: initial;
}
</style>
